module.exports = __webpack_public_path__ + "assets/botlay.6ebd9a20.svg";